<template>
    <div class="px-0">
        <v-container class="px-0 py-5" style="max-width: 100% !important">
            <v-card class="px-0 py-3 size">
                <v-row class="px-5 pt-5">
                    <v-col cols="12" align="center" justify="center">
                        <h3 class="blue_accent--text text-uppercase">{{ $t('edit_customer.update_fees') }} {{
                            client_name }}</h3>
                    </v-col>
                </v-row>
                <v-card-text class="px-0">
                    <v-form ref="form" lazy-validation @submit.prevent="save">

                        <!-- Settings -->
                        <v-row class="px-5 py-0 mt-2 mb-0" justify="center" align="center">
                            <v-col cols="6" class="py-0">
                                <v-expansion-panels>
                                    <v-expansion-panel v-for="(item, i) in settings" :key="i">
                                        <v-expansion-panel-header>
                                            {{ $t('create_customer.' + i) }}
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content class="mt-2">
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service != 'CHRONOS' && item.shipping_service != 'REFERENCES'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].fulfillment"
                                                        :label="$t('create_customer.fulfillment_quote')"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].label"
                                                        :label="$t('create_customer.label_printing_quote')"></v-text-field>
                                                </v-col>
                                            </v-row>

                                            <!-- FEDEX -->
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service == 'FEDEX'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].zone_1"
                                                        :label="$t('create_customer.zone_1')"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].zone_2"
                                                        :label="$t('create_customer.zone_2')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service == 'FEDEX'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].zone_3"
                                                        :label="$t('create_customer.zone_3')"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].zone_4"
                                                        :label="$t('create_customer.zone_4')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service == 'FEDEX'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].zone_5"
                                                        :label="$t('create_customer.zone_5')"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].zone_6"
                                                        :label="$t('create_customer.zone_6')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service == 'FEDEX'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].zone_7"
                                                        :label="$t('create_customer.zone_7')"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].zone_8"
                                                        :label="$t('create_customer.zone_8')"></v-text-field>
                                                </v-col>
                                            </v-row>

                                            <!-- REST OF SHIPPING SERVICES -->
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service != 'CHRONOS' && item.shipping_service != 'REFERENCES'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-autocomplete class="mt-0 py-0"
                                                        v-model="settings[i].is_porcentual" item-text="text"
                                                        item-value="value" :items="behaviors"
                                                        :label="$t('create_customer.is_porcentual')"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].cod_fee"
                                                        :label="$t('create_customer.cod_collection_quote')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service != 'CHRONOS' && item.shipping_service != 'REFERENCES'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].return_1kg"
                                                        :label="$t('create_customer.return1kg_quote')"></v-text-field>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].extended_zone"
                                                        :label="$t('create_customer.ext_zone_quote')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service != 'CHRONOS' && item.shipping_service != 'REFERENCES'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].packing_1kg"
                                                        :label="$t('create_customer.packing1kg_quote')"></v-text-field>
                                                </v-col>

                                                <v-col cols="6" class="py-0" style="display:flex"
                                                    v-if="item.shipping_service != 'FEDEX'">
                                                    <v-text-field class="py-0" v-model="settings[i].shipping_1kg"
                                                        :label="$t('create_customer.shiping1kg_quote')"></v-text-field>
                                                </v-col>
                                                <v-spacer v-if="item.shipping_service == 'FEDEX'"></v-spacer>
                                            </v-row>
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service == 'CHRONOS'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0"
                                                        v-model="settings[i].storage_per_pallet_cost"
                                                        :label="$t('create_customer.storage_per_pallet')"></v-text-field>
                                                </v-col>

                                                <v-col cols="6" class="py-0" style="display:flex"
                                                    v-if="item.shipping_service != 'FEDEX'">
                                                    <v-text-field class="py-0" v-model="settings[i].managing_cost"
                                                        :label="$t('create_customer.managing')"></v-text-field>
                                                </v-col>
                                                <v-spacer v-if="item.shipping_service == 'FEDEX'"></v-spacer>
                                            </v-row>

                                            <!-- REFERENCES -->
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service == 'REFERENCES'">
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-autocomplete class="mt-0 py-0"
                                                        v-model="settings[i].paid_reference_is_porcentual"
                                                        item-text="text" item-value="value" :items="behaviors"
                                                        :label="$t('create_customer.porcentual_reference')"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="6" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].paid_reference"
                                                        :label="$t('create_customer.paid_reference')"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row class="px-0 py-0 my-0" justify="center" align="center"
                                                v-if="item.shipping_service == 'REFERENCES'">
                                                <v-col cols="12" class="py-0" style="display:flex">
                                                    <v-text-field class="py-0" v-model="settings[i].expired_reference"
                                                        :label="$t('create_customer.expired_reference')"></v-text-field>
                                                </v-col>
                                            </v-row>

                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-col>
                        </v-row>
                    </v-form>

                    <v-row class="px-5 py-0 mt-2" justify="center" align="center">
                        <v-col cols="6" justify="end" align="end">
                            <v-btn class="right px-3 mx-4" @click="cancel">
                                {{ $t('edit_customer.cancel') }}
                            </v-btn>
                            <v-btn class="right white_highlight--text" color="secondary" @click="save"
                                v-permission="'client.update'">
                                {{ $t('edit_customer.save') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-container>
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color"
            style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import { HttpCustomerRepository } from '../infrastructure/customer_repository';
import { customerShowUseCase } from '../application/use_cases/customer_show_use_case';

export default {
    computed: {
        rules_required() { return [v => !!v || this.$t('create_appointment.validations.required_field')] }
    },
    data() {
        return {
            id: this.$route.params.id,
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            client_name: "",
            settings: {
                fedex: {
                    shipping_service: 'FEDEX',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    zone_1: 0,
                    zone_2: 0,
                    zone_3: 0,
                    zone_4: 0,
                    zone_5: 0,
                    zone_6: 0,
                    zone_7: 0,
                    zone_8: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                quiken: {
                    shipping_service: 'QUIKEN',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                yego: {
                    shipping_service: 'YEGO',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                otra: {
                    shipping_service: 'OTRA',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                merq: {
                    shipping_service: 'MERQ',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                jtexpress: {
                    shipping_service: 'JTEXPRESS',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                afimex: {
                    shipping_service: 'AFIMEX',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                cexpress: {
                    shipping_service: 'CEXPRESS',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                tiui: {
                    shipping_service: 'TIUI',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                ihs: {
                    shipping_service: 'IHS',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                qualitypost: {
                    shipping_service: 'QUALITYPOST',
                    fulfillment: 0,
                    label: 0,
                    cod_fee: 0,
                    shipping_1kg: 0,
                    shipping_2kg: 0,
                    return_1kg: 0,
                    packing_1kg: 0,
                    extended_zone: 0,
                    is_porcentual: false,
                },
                chronos: {
                    shipping_service: 'CHRONOS',
                    storage_per_pallet_cost: 0,
                    managing_cost: 0
                },
                references: {
                    shipping_service: 'REFERENCES',
                    paid_reference: 0,
                    paid_reference_is_porcentual: false,
                    expired_reference: 0,
                }
            },
            behaviors: [{ text: this.$t("create_customer.porcentual"), value: true }, { text: this.$t("create_customer.fixed"), value: false }]
        }
    },
    mounted() {
        this.index();
        this.$store.state.module = "headers.edit_customer";
    },
    methods: {
        async index() {
            try{
                const res = await customerShowUseCase(this.id, HttpCustomerRepository);                
                
                this.client_name = res[0];
                this.settings = res[1];
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        save() {
            const validate = this.$refs.form.validate()


            if (validate) {
                this.$store.state.loaderProps.visible = true;

                const lsToken = localStorage.getItem("access_token");
                this.$http.put(this.$store.state.chronosApi + 'clientsFees/' + this.id, { "settings": this.settings }, { headers: { Authorization: lsToken } })
                    .then((response) => {
                        if (response.status === 200) {
                            this.snackbar = {
                                visible: true,
                                color: 'success2',
                                text: this.$t('create_custom_agent.responses.success')
                            }
                            this.$router.push({ name: "CustomersIndex" });
                        }
                        this.$store.state.loaderProps.visible = false;
                    })
                    .catch((response) => {
                        this.$store.state.loaderProps.visible = false;
                        if (response.status !== 200) {
                            this.snackbar = {
                                visible: true,
                                color: 'red',
                                text: this.$t('pendings.responses.error')
                            }
                        }
                    });
            }
            else {
                this.snackbar = {
                    visible: true,
                    color: 'red',
                    text: this.$t('create_customer.invalid_form')
                }
            }
        },
        cancel() {
            this.$router.go(-1);
        },
    },
    watch: {

    }
}
</script>

<style lang="css"></style>